import { m } from "@/paraglide/messages";

export interface TimerExplainerProps {
  howTo: string;
  faqs: Array<{ q: string; a: string }>;
  /** Duration-specific "common uses" — what makes each preset page unique. */
  uses?: string[];
}

/** How-to + FAQ block. The matching FAQPage JSON-LD is emitted by the route. */
export function TimerExplainer({ howTo, faqs, uses }: TimerExplainerProps) {
  return (
    <div className="mt-12 space-y-10">
      <section className="pct-card space-y-4 rounded-2xl p-6 sm:p-7">
        <h2 className="font-display text-xl font-bold tracking-tight">
          {m.timer_howto_title()}
        </h2>
        {howTo.split("\n\n").map((p) => (
          <p
            key={p}
            className="max-w-2xl leading-relaxed text-muted-foreground"
          >
            {p}
          </p>
        ))}
        {uses && uses.length > 0 && (
          <div className="space-y-2.5 pt-1">
            <h3 className="text-xs font-semibold tracking-wider text-muted-foreground uppercase">
              {m.timer_uses_title()}
            </h3>
            <ul className="space-y-2.5">
              {uses.map((u) => (
                <li
                  key={u}
                  className="pct-example flex items-start gap-3 rounded-lg py-3 pr-4 pl-4 text-sm text-foreground/90"
                >
                  <span aria-hidden className="pct-result mt-px">
                    →
                  </span>
                  <span>{u}</span>
                </li>
              ))}
            </ul>
          </div>
        )}
      </section>

      <section className="space-y-4">
        <h2 className="px-1 font-display text-xl font-bold tracking-tight">
          {m.timer_faq_title()}
        </h2>
        <dl className="space-y-3">
          {faqs.map((f) => (
            <div key={f.q} className="pct-panel rounded-xl p-5">
              <dt className="flex items-start gap-3 font-semibold text-foreground">
                <span
                  aria-hidden
                  className="pct-chip grid h-6 w-6 shrink-0 place-items-center rounded-md font-display text-xs font-bold"
                >
                  Q
                </span>
                <span className="pt-0.5">{f.q}</span>
              </dt>
              <dd className="mt-2 pl-9 text-sm leading-relaxed text-muted-foreground">
                {f.a}
              </dd>
            </div>
          ))}
        </dl>
      </section>
    </div>
  );
}
